<ng-container *ngIf="planObj?.autopayDiscDetails?.autoPayAllowed">
    <div #discountContentDIV [innerHTML]="discountContent" (click)=openDiscountModal($event)>
    </div>
  </ng-container>  